import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ArrowRightIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         {...props}
         viewBox="0 0 24 24"
         fill="none"
      >
         <g clipPath="url(#clip0_10531_58634)">
            <path
               d="M18.9298 13.204L7.70176 23.4783C7 24.1739 5.77193 24.1739 5.07018 23.4783C4.30994 22.8361 4.30994 21.7124 5.07018 21.0702L14.9532 12.0268L5.07017 2.92977C4.30994 2.28763 4.30994 1.16388 5.07017 0.521741C5.77193 -0.173911 7 -0.173911 7.70175 0.521741L18.9298 10.796C19.6901 11.4381 19.6901 12.5619 18.9298 13.204Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10531_58634">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default ArrowRightIcon
